import React from 'react';
import { Controller } from 'react-hook-form';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from "@mui/material/FormControlLabel";

const FormCheckbox = ({ name, disabled, label, ...restProps }) => {
  return (
      <Controller
          name={name}
          render={({ field }) => {
            if (!field.value) field.value = false;
            return (
                <FormControlLabel
                    control={<Checkbox {...restProps}
                                       {...field}
                                       checked={field.value}
                                       disabled={disabled} />}
                    label={label} />
            )
          }}
      />
  )
};

export default FormCheckbox;
